import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { Button } from '@/components/ui/button'
import { signOut } from '@/lib/auth'

export const SignOut = () => {
  const navigate = useNavigate()

  const handleSignOut = useCallback(async () => {
    try {
      await signOut()
      navigate('/')
    } catch (error) {
      console.error('サインアウトエラー:', error)
    }
  }, [navigate])

  const handleCancel = useCallback(() => {
    navigate(-1)
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-linear-to-br from-gray-900 to-gray-800">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-8 max-w-md w-full mx-4">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">サインアウト</h1>

          <p className="text-gray-600 dark:text-gray-300 mb-8">
            本当にサインアウトしますか？
            <br />
            保存されていないデータは失われる可能性があります。
          </p>

          <div className="flex flex-col gap-3">
            <Button onClick={handleSignOut} variant="destructive" className="w-full">
              サインアウト
            </Button>

            <Button onClick={handleCancel} variant="outline" className="w-full">
              キャンセル
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
